import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import profileData from '../data/profile.json';

const Profile = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <section className="mb-16">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col md:flex-row items-center gap-8"
      >
        <div className="w-3/5 md:w-1/2 mx-auto bg-gray-600 rounded-lg">
          <img 
            src={profileData.image}
            alt={profileData.name}
            className="rounded-lg shadow-lg w-full"
          />
        </div>
        <div className="w-full md:w-2/3">
          <h1 className="text-4xl font-bold mb-4 text-primary text-center md:text-left">
            {profileData.name}
          </h1>
          <p className="text-xl text-muted-foreground mb-6 text-center md:text-left">
            {profileData.title}
          </p>
          <div className="prose prose-lg text-muted-foreground space-y-4">
            <p className="leading-relaxed">{profileData.bio[0]}</p>
            <p className="leading-relaxed">{profileData.bio[1]}</p>
            
            <AnimatePresence>
              {isExpanded && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3 }}
                  className="space-y-4"
                >
                  {profileData.bio.slice(2).map((paragraph, index) => (
                    <p key={index} className="leading-relaxed">{paragraph}</p>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
            
            <div className="flex justify-center md:justify-start">
              <button 
                onClick={() => setIsExpanded(!isExpanded)}
                className="flex items-center text-primary hover:text-primary/80 transition-colors"
              >
                {isExpanded ? 'Show Less' : 'Read More'}
                <motion.div
                  animate={{ rotate: isExpanded ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="ml-1"
                >
                  <ChevronDown className="w-4 h-4" />
                </motion.div>
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Profile;
